import "./Features.css";

function Features() {
  return (
    <div>
      <h1>This is a Features Section</h1>
    </div>
  );
}
export default Features;
